<template>
  <div>
    <v-card class="ma-2">
      <v-card-title class="green accent-3">
        Profil User
      </v-card-title>
      <v-card-text class="pa-4">
        <v-row>
          <v-col cols="2" class="subtitle-1 font-weight-bold mt-4 text-right">
            User ID / Login
          </v-col>
          <v-col cols="4">
            <v-text-field
              single-line
              readonly
              v-model="login"
              class="my-text-style"
            ></v-text-field>
          </v-col>
          <v-col cols="1" class="subtitle-1 font-weight-bold mt-4 text-right">
            E-Mail
          </v-col>
          <v-col cols="4">
            <v-text-field
              single-line
              readonly
              v-model="email"
              class="my-text-style"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="2" class="subtitle-1 font-weight-bold mt-4 text-right">
            Nama
          </v-col>
          <v-col cols="4">
            <v-text-field
              single-line
              readonly
              v-model="nama"
              class="my-text-style"
            ></v-text-field>
          </v-col>
          <v-col cols="1" class="subtitle-1 font-weight-bold mt-4 text-right">
            Jabatan
          </v-col>
          <v-col cols="4">
            <v-text-field
              single-line
              readonly
              v-model="jabatan"
              class="my-text-style"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <template v-if="roles !== 'vendor'">
          <v-col cols="2" class="subtitle-1 font-weight-bold mt-4 text-right">
            Divisi / Unit
          </v-col>
          <v-col cols="4">
            <v-text-field
              single-line
              readonly
              v-model="divisi"
              class="my-text-style"
            ></v-text-field>
          </v-col>    
          </template>
          <template v-else>
            <v-col cols="1"></v-col>
          </template>
          <v-col cols="1" class="subtitle-1 font-weight-bold mt-4 text-right">
            Role
          </v-col>
          <v-col cols="4">
            <v-text-field
              single-line
              readonly
              v-model="roles"      
              class="my-text-style"        
            ></v-text-field>
          </v-col>     
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="ma-2">
      <v-card-title class="green accent-3">
        Ubah Password
      </v-card-title>
      <v-card-text class="pa-4">
        <v-form ref="formPass" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="6">
              <v-text-field
                label="Masukkan password lama"
                outlined
                type="password"
                v-model="oldPass"
              ></v-text-field>
            </v-col>        
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                label="Masukkan password baru"
                type="password"
                v-model="newPass"
                outlined
                :rules="[ rules.required, rules.minPass ]"
              ></v-text-field>
            </v-col>   
            <v-col cols="6">
              <v-text-field
                label="Konfirmasi password baru"
                type="password"
                v-model="newPass2"
                outlined
                :rules="[ rules.required, rules.minPass, rules.passwordConfirm(newPass) ]"
              ></v-text-field>
            </v-col>      
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn color="success" dark @click="simpanClick">Simpan</v-btn>
        <v-btn color="info" dark @click="resetForm">Reset</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
const apiUrl = process.env.VUE_APP_ROOT_API
import axios from 'axios'
import { rules as Rules } from './../../lib/rules'
import { getValueItem, itemsUserRoles, itemsDivisi, itemsUserStatus } from "./../../lib/viewLib"

export default {
  data: function() {
    return {
      valid: true,
      login: '',
      email: '',
      nama: '',
      jabatan: '',
      divisi: '',
      roles: '',
      oldPass: '',
      newPass: '',
      newPass2: '',
      rules: {
        required: Rules.required,
        passwordConfirm: Rules.passwordConfirm,
        minPass: value => value.length >= this.$store.getters.PANJANG_MIN_PASSWD || `Password minimal ${this.$store.getters.PANJANG_MIN_PASSWD} karakter`,
      },
      itemsUserRoles: itemsUserRoles,
      itemsDivisi: itemsDivisi,
      itemsUserStatus: itemsUserStatus,
    }
  },
  methods: {
    getValueItem: getValueItem,
    resetForm: function() {
      this.$refs.formPass.reset() 
    },
    simpanClick: async function() {
      const mess = {
        id: this.$store.getters.userInfo.userId,
        oldPass: this.oldPass,
        newPass: this.newPass,
        kind: 'C'
      }
      await axios.put(apiUrl+'/userman/changepwd', mess)
      .then((response) => {
        console.log(response)
        this.$store.dispatch('displayAlert', {color: 'success', message: 'Password telah berhasil diubah'})
        window.scroll(0,0)
      })
      .catch((err) => {
        this.$store.dispatch('displayAlert', {color: 'error', message: err.response.data.message})
        window.scroll(0,0)
      })      
    }
  },
  created: async function() {
    const userId = this.$store.getters.userInfo.userId
    await axios.get(apiUrl+'/userman/id/'+userId)
    .then((response) => {
      this.login = response.data.data.login
      this.email = response.data.data.email
      this.nama = response.data.data.nama
      this.jabatan = response.data.data.jabatan
      this.divisi = this.getValueItem(this.itemsDivisi, response.data.data.divisi)
      this.roles = this.getValueItem(this.itemsUserRoles, response.data.data.roles)
      console.log("Roles: ", this.roles);
    })
    .catch((err) => {
      this.$store.dispatch('displayAlert', {color: 'error', message: err.response.data.message})
      window.scroll(0,0)
    })
  }
}
</script>

<style scoped>
.my-text-style >>> .v-text-field__slot input {
  color: blue
}
</style>